<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="demo-form-inline backborder1" ref="search" size="small">
        <el-form-item>
          <el-input placeholder="请输入条形码" v-model="productquery.key">
            <template slot="prepend">查找</template>
            <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addDialogShow">添加商品</el-button>
          <el-badge :value="lists.length > 0 ? lists.length : ''" class="item">
            <el-button type="" icon="el-icon-delete" @click="delcart">清空商品</el-button>
          </el-badge>
        </el-form-item>
      </el-form>


      <div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
        <div class="cz-sell-base-lists-infos-out">
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">单据编号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input v-model="create.documents" placeholder="单据编号" :disabled="true" />
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">退款日期</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.paydate" style="width:99%;"
                value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">退款日期</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择录单日期" v-model="create.inputdate"
                style="width:99%;"></el-date-picker>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">退款账号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.account" filterable placeholder="请选择付款帐号">
                <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" :value="item.id"
                  v-if="item.id != ''"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">退货备注</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input placeholder="出库备注" v-model="create.note"></el-input>
            </div>
          </div>
          <!-- <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">配送方式</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.account" filterable placeholder="请选择配送方式">
                <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" :value="item.id"
                  v-if="item.id != ''"></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">快递公司</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.logisticsid" clearable remote  filterable placeholder="请选择物流公司">	            
                <el-option v-for="(item,index) in otherlogistics" :label="item.showlable" :value="item.id" :key="item.id">
                  <span style="float: left">{{item.name}}</span>
                  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                </el-option>              
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">快递单号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input placeholder="请输入物流单号" v-model="create.shippingcode"></el-input>
            </div>
          </div>
        </div>


        <div class="cz-sell-base-lists-infos-goods" style="margin-top:10px">
          <el-table :data="lists" border v-loading="listsLoading" show-summary :summary-method="totalRule">
            <el-table-column label="商品名称" min-width="250">
              <template slot-scope="scope">
                <div style="font-size:13px">{{ scope.row.name }}</div>
                <div style="font-size:12px;color:#999999">编号：{{ scope.row.number }}</div>
              </template>
            </el-table-column>
            <el-table-column label="退货客户" min-width="140" align="center">
              <template slot-scope="scope">
                <div style="font-size:13px">{{ scope.row.sellcustomer }}</div>
              </template>
            </el-table-column>
            <el-table-column label="关联销售单号" min-width="140" align="center">
              <template slot-scope="scope">
                <div style="font-size:13px">{{ scope.row.selldocuments }}</div>
              </template>
            </el-table-column>
            <el-table-column label="退货仓库" align="center" min-width="140">
              <template slot-scope="scope">
                <!-- <div style="font-size:13px;width:100%;text-align:center">{{scope.row.warehousename}}</div> -->
                <div class="cz-sell-base-lists-infos-content">
                  <el-select v-model="scope.row.warehouse" placeholder="请选择收货仓库" @change="warehouseChange(scope.row)">
                    <el-option v-for="(item, index) in warehouseNew" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="*退回货位" align="center" min-width="140" v-if="goodsLocationStatus && !batchStatus">
              <template slot-scope="scope">
                <div class="link-style" @click="showSelectLocation(scope.$index, scope.row)">
                  <span v-if="!scope.row.storage_location_id">请选择</span>
                  <span v-else>{{ scope.row.full_code || scope.row.storage_location_code }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="货位/批次" align="center" min-width="300" v-if="goodsLocationStatus && batchStatus">
              <template slot-scope="scope">
                <div >
                  <span v-if="!scope.row.batch_sn">/</span>
                    <div>{{ scope.row.full_code }}</div>
                    <div v-if="batchStatus">
                      <div style="color: #909399;">
                        {{ scope.row.batch_sn }}
                        <span v-if="scope.row.start_date && scope.row.start_date != '0' && scope.row.end_date && scope.row.end_date != '0'">
                          [<span style="color: #F56C6C;">{{ scope.row.start_date }}至{{ scope.row.end_date }}</span>]
                        </span>
                      </div>
                    </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column label="销售成交单价" align="center" min-width="140">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.buy" @blur="changebuys(scope.row)" />
              </template>
            </el-table-column>
            <el-table-column label="退货数量" align="center" min-width="170">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.num" @blur="changeNum(scope.$index, scope.row)"
                  class="cz-table-refund-num-style1">
                  <template slot="append">{{ scope.row.unit }}</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="销售成交小计" align="center" min-width="140">
              <template slot-scope="scope">
                <div style="font-size:13px;width:100%;text-align:center">{{ scope.row.total }}</div>
              </template>
            </el-table-column>
            <el-table-column label="生产日期" align="center" min-width="200">
              <template slot-scope="scope">
                <el-date-picker size="small" type="date" value-format="yyyy-MM-dd" placeholder="生产日期"
                  v-model="scope.row.validity" @change="changeValidity(scope.$index, scope.row)"
                  style="width:99%;"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" round @click="deltempCurrent(scope.row)" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="border:1px solid #fff;border-radius:6px;padding:1% 1% 1% 1%;width:98%;float:left;background:#fff;">
          <div v-if="!batchStatus" slot="footer" class="dialog-footer" style="text-align:right;padding:10px 0 20px 0;">
            <el-button size="small" type="primary" @click="createPrint" :loading="saveorderLoading">保存</el-button>
            <el-button size="small" type="warning" @click="verifysave" :loading="verifyLoading">审核</el-button>
            <el-button size="small" type="warning" @click="createandPrint"
              :loading="saveandprintLoading">保存并打印</el-button>
          </div>
          <div v-if="batchStatus" slot="footer" class="dialog-footer" style="text-align:right;padding:10px 0 20px 0;">
            <el-button size="small" type="primary" @click="rukudialogVisible = true">入库并保存</el-button>
          </div>
        </div>

      </div>


      <!----------------------- 批量添加商品模块 ----------------------->
      <el-dialog title="批量添加退货商品" :visible.sync="addDialog" width="80%" top="5vh">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
              <el-option label="不分品牌" value="0"></el-option>
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productquery.customerid" clearable filterable remote reserve-keyword
              :remote-method="getCustomer" @change="isnewselect = true" :loading="customerLoading"
              placeholder="请输入客户名称 / 简称">
              <el-option v-for="(item, index) in customerLists" :key="index" :label="item.showname"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item ref="productquery" :model="productquery">
            <el-input placeholder="商品名称 / 条形码 / 编号" clearable v-model="productquery.key"
              @keyup.enter.native="getProductList" @change="isnewselect = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-badge :value="multipleSelection.length > 0 ? multipleSelection.length : ''" class="item">
              <el-button type="" icon="el-icon-delete" @click="cleargoods">清空选中商品</el-button>
            </el-badge>
          </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading"
          @row-click="handleSelectRow" @select="handleselect" @select-all="addmultipleTable">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="商品名称" min-width="250">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.name }}</div>
              <div style="font-size:12px;color:#999999">编号：{{ scope.row.number }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="退货客户" align="center" min-width="140">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.customername }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="关联退货单号" align="center" min-width="140">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.documents }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="可退数量" align="center" min-width="100">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.refundnum }} {{ scope.row.baseunit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="退货数量" align="center" min-width="100">
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.paynums" size="small" @focus="paynumfocus"
                @blur="paynumblur(scope.row)">
                <template slot="append">{{ scope.row.baseunit }}</template>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_product_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
        </div>
      </el-dialog>

      <!-------------------- 打印页 --------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="10vh">
        <div style="width:100%;text-align:right">
          <span v-if="printorderdetail.printnumber > 0" style="float:left;color:#E6A23C">本订单已打印
            {{ printorderdetail.printnumber }} 次</span>
          每页展示 <input type="text" v-model="rollpage" v-on:blur="changepagevlaue()"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条
        </div>
        <div id="printContent" v-loading="printLoading">
          <div v-for="(iit, i) in prpage">
            <span style="float:right">{{ iit.id }}/{{ allprintpage }}</span>
            <DIV style="font-size:18px;padding-bottom:2px;" align="center" v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <ul class="titlelists">
              <li v-if="printsmodel.customer_name == 1">客户名称：{{ printorderdetail.customername }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ printorderdetail.documents }}</li>
              <li v-if="printsmodel.desc == 1">入库备注：{{ printorderdetail.note }}</li>
              <li v-if="printsmodel.contactphone == 1">客户电话：{{ printorderdetail.contactphone }}</li>
              <li v-if="printsmodel.accountname == 1">退款方式：{{ printorderdetail.accountName }}</li>
              <li v-if="printsmodel.deliverdate == 1">退款日期：{{ printorderdetail.paydate }}</li>
              <li v-if="printsmodel.address == 1" style="width:100%">客户地址：{{ printorderdetail.contactaddress }}</li>
            </ul>
            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px"
              bordercolor="#333333">
              <thead>
                <TR class="contactcontent">
                  <TD v-if="printsmodel.number == 1">
                    <DIV align=center><b>编号</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.product_name == 1">
                    <DIV align=center><b>品名</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.product_spec == 1">
                    <DIV align=center><b>规格</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.unit == 1">
                    <DIV align=center><b>单位</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.num == 1">
                    <DIV align=center><b>数量</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.sell == 1">
                    <DIV align=center><b>售价</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.amount == 1">
                    <DIV align=center><b>小计</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.warehourse == 1">
                    <DIV align=center><b>仓库</b></DIV>
                  </TD>
                  <!--<TD v-if="printsmodel.refunddate==1"><DIV align=center><b>有效期</b></DIV></TD>-->
                </TR>
              </thead>
              <TBODY>
                <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                  v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage']">
                  <TD v-text="item.number" align="center" v-if="printsmodel.number == 1"></TD>
                  <TD v-text="item.name" style="padding-left:20px" v-if="printsmodel.product_name == 1"></TD>
                  <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec == 1"></TD>
                  <TD v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></TD>
                  <TD v-text="item.num" align="center" v-if="printsmodel.num == 1"></TD>
                  <TD v-text="item.sell" align="center" v-if="printsmodel.sell == 1"></TD>
                  <TD v-text="item.amount" align="center" v-if="printsmodel.amount == 1"></TD>
                  <TD v-text="item.warehousename" align="center" v-if="printsmodel.warehourse == 1"></TD>
                  <!--<TD v-text="item.validity" align="center" v-if="printsmodel.refunddate==1"></TD>-->
                </tr>
                <tr v-if="iit.id == allprintpage">
                  <TD align="center" v-if="printsmodel.number == 1 || printsmodel.product_name == 1"><b>合计</b></TD>
                  <TD v-if="printsmodel.number == 1 && printsmodel.product_name == 1"></TD>
                  <TD v-if="printsmodel.product_spec == 1">&nbsp;</TD>
                  <TD v-if="printsmodel.unit == 1">&nbsp;</TD>
                  <TD align="center" v-if="printsmodel.num == 1">{{ printorderdetail.allnums }}</TD>
                  <TD v-if="printsmodel.sell == 1">&nbsp;</TD>
                  <TD align="center" v-if="printsmodel.amount == 1">{{ printorderdetail.total }}</TD>
                  <TD v-if="printsmodel.warehourse == 1">&nbsp;</TD>
                  <!--<TD v-if="printsmodel.refunddate==1">&nbsp;</TD>-->
                </tr>
              </TBODY>
            </table>
            <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="margin-top:2px;font-size:15px">
              <TBODY>
                <TR>
                  <TD v-if="printsmodel.inputdate == 1">录单日期：{{ printorderdetail.inputdate }}</TD>
                  <TD v-if="printsmodel.total == 1">总计：{{ printorderdetail.total }}</TD>
                  <TD v-if="printsmodel.sysmanagername == 1">操作人：{{ printorderdetail.sysmanagername }}</TD>
                </TR>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeprint">取 消</el-button>
          <el-button size="small" type="primary" @click="createnoSave" :loading="printorderLoading">打印</el-button>
        </div>
      </el-dialog>

      <!---------------------------修改单位--------------------------->
      <el-dialog title="单位选择" :visible.sync="unitDialog">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column label="单位" prop="unit"></el-table-column>
          <el-table-column label="售价" prop="sell"></el-table-column>
          <el-table-column label="市场价" prop="market"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeUnitSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!---------------------------修改仓库--------------------------->
      <el-dialog title="仓库选择" :visible.sync="wareDialog" width="40%">
        <el-table :data="wareHouseLists" style="width: 100%" v-loading="wareListLoading">
          <el-table-column label="仓库名称" prop="name"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeWareSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!---------------------------修改仓库--------------------------->

      <!---------------------------修改货位--------------------------->
      <el-dialog title="选择货位" :visible.sync="locationDialog" @close="locationParams.keyword = ''">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-input placeholder="请输入搜索关键词" v-model="locationParams.keyword" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="locationSearch()">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="locationList" style="width: 100%" v-loading="locationDialogLoading">
          <el-table-column label="货位号" align="left" header-align="center" prop="full_code"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" icon="el-icon-check"
                @click="selectLocation(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="locationPageSizeChange" @current-change="locationPageCurrentChange"
            :current-page="locationParams.p" :page-sizes="[10, 20, 50]" :page-size="locationParams.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="locationParams.total">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>

      <!-- 入库弹窗 -->
      <el-dialog title="选择入库方式" :visible.sync="rukudialogVisible" width="300px">
        <el-radio-group v-model="selectedOption">
          <el-radio label="1">PC入库</el-radio>
          <el-radio label="2">PDA入库</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rukudialogVisible = false" style="margin-right: 10px;">取消</el-button>
          <el-button type="primary" @click="saveRefundedGoods">确认</el-button>
        </span>
      </el-dialog>

      <ChangeBatch ref="ChangeBatch" selectType="2" @confirm="batchConfirm" />
    </div>
  </transition>



</template>

<script>
import ChangeBatch from '@/components/home/ChangeBatch.vue';
export default {
  props: ['childdata'],
  components: { ChangeBatch },
  data() {
    return {
      url: this.GLOBAL.domain + "Refund/index",
      transitionshow: true,
      rukudialogVisible: false,
      selectedOption: '',
      actionauth: [],
      customer: '',
      create: {
        id: '',
        act: 'addrefund',
        token: this.$cookies.get('token'),
        paydate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        lists: '',
        account: '',
        documents: '',
        customer: '',
        inputdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        node: '',
        buys: [],
        nums: [],
        totals: [],
        validitys: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        warehouses: [],
        note: '',
        seller: '',
        shippingcode: '',
        logisticsid: ''
      },
      productquery: {
        act: 'inventory_new',
        token: this.$cookies.get('token'),
        id: '',
        brandid: '',
        catid: '',
        warehouse: '',
        customerid: '',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      customerLists: [],
      lists: [],
      listsLoading: false,
      buys: [],
      nums: [],
      totals: [],
      customerLoading: false,
      accountLists: [],
      saveorderLoading: false,
      verifyLoading: false,
      saveandprintLoading: false,
      multipleSelection: [],
      validitys: [],
      warehouses: [],
      addDialog: false,
      brandlists: [],
      categorylist: [],
      isnewselect: false,
      addListLoading: false,
      total_product_rows: 0,
      addProductLoading: false,
      // warehouselists: [],
      sellerLists: [],
      printerDialog: false,
      printorderdetail: [],
      rollpage: 10,
      printLoading: false,
      prpage: [],
      prollpage: [],
      allprintpage: '',
      printorderLoading: false,
      unitDialog: false,
      unitListLoading: false,
      wareDialog: false,
      wareListLoading: false,
      prtotal: 0,
      contactname: '',
      contactphone: '',
      contactaddress: '',
      saveorderLoading: false,
      saveandprintLoading: false,
      isselectpaynums: false,
      productlists: [],
      unitlists: [],
      locationList: [],
      warehouseNew: [],
      goodsLocationStatus: false,
      storageLocationInIds: [],
      locationDialog: false,
      locationList: [],
      locationDialogLoading: false,
      locationParams: {
        keyword: '',
        rollpage: 10,
        p: 1,
        total: 0
      },
      editListIndex: '',
      editRow: {},
      wareHouseLists: [],
      otherlogistics:[],
      batchStatus: false,
    }
  },


  mounted() {
    this.getactionauth(); //获取权限设置
    //   this.edit(); //编辑退货商品信息
    this.getBrand(); //品牌列表
    this.getCategoryList(); //分类信息列表
    this.getWarehouse();
    this.getAccount(); //获取支付方式
    this.getprintsmodel(); //获取模板设置权限
    this.getSeller(); //获取销售员列表
    this.checkLocationStatus()
    this.getallshippinglogistics()
    this.getLists()
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },


  methods: {
    batchConfirm({row, batchRow}) {
      this.$axios({
        url: this.GLOBAL.domain + 'Refund/index',
        method: 'post',
        data: {
          act: 'refund_batch_update',
          id: row.id,
          batch_storage_inventory_id: batchRow.id || ''
        }
      })
        .then(res => {
          if (res.Result === 0) {
            this.$message.success('操作成功!');
            this.getLists(); //刷新购物车界面

            // this.$emit('listenchild',{name:'编辑进货入库单',url:'Storageedit',data:item});
          }
        })
    },
    // 入库并保存
    saveRefundedGoods() {
      this.saveorderLoading = true;
      var resource = this.$resource(this.url);
      this.create.act = 'create_and_save_return_storage';
      this.create.type = this.selectedOption

      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveorderLoading = false;
        } else {
          this.$message.success('入库并保存操作成功！');
          this.saveorderLoading = false;
          //this.getLists();
          this.selectedOption = ''
          const data = JSON.parse(Base64.decode(res.data.Data));
          this.rukudialogVisible = false
          if (this.create.type == '1') {
            this.$emit('listenchild',{name:'编辑进货入库单',url:'Storageedit',data:{ id: data.id }});
          }
          this.$emit('closechild', 'Refundadd');
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.saveorderLoading = false;
      });
    },
    //获取第三方商品发货快递信息
    getallshippinglogistics() {
      var resource = this.$resource(this.GLOBAL.domain+"Order/index");
      resource.query({act:'getallshippinglists',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.otherlogistics=JSON.parse(Base64.decode(res.data.Data));
          }
      }).catch((res) => {
          
      });
    },
    switchingBatches(row) {
      this.$refs.ChangeBatch.openDialog(row)
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 编辑订单信息 **/
    edit() {
      var item = this.childdata;
      var resource = this.$resource(this.url);
      resource.query({ act: 'editorder_news', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.customer = result.customername;
          this.create.id = item.id;
          this.create.paydate = result.paydate;
          this.create.lists = [];
          this.create.account = result.account == 0 ? "" : result.account;
          this.create.documents = result.documents;
          this.create.customer = result.customer == 0 ? "" : result.customer;
          this.productquery.customerid = result.customer == 0 ? "" : result.customer;
          this.create.inputdate = result.inputdate;
          this.create.buys = [];
          this.create.nums = [];
          this.create.totals = [];
          this.create.validitys = new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
            this.create.warehouses = [];
          this.create.note = result.note;
          this.create.seller = result.clerkid == 0 ? "" : result.clerkid;
          this.getLists(); //获取退货信息
        }
      }).catch((res) => {

      });
    },

    /** 获取打印模板设置 **/
    getprintsmodel() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getmodelsetting', id: 5, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取退款信息 **/
    getLists() {
      this.listsLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'refundlists_news', token: this.$cookies.get('token'), rollpage: 1000, id: this.create.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listsLoading = false;
        } else {
          const tempLists = JSON.parse(Base64.decode(res.data.Data));
          console.log(tempLists, '新增退货订单列表')
          const getData = async () => {
            const warehouse = await this.getLatestWarehouse()
            this.warehouseNew = warehouse
            if (Array.isArray(tempLists) && tempLists.length > 0) {
              for (const element of tempLists) {
                element["location_children"] = []
                if (Array.isArray(warehouse) && warehouse.length > 0) {
                  for (const element_ of warehouse) {
                    if (element.warehouse == element_.id) {
                      element["location_children"] = element_.children
                      break
                    }
                  }
                }
              }
            }
            this.lists = tempLists
            this.listsLoading = false;
            //重置订单数据
            this.resetcreate();
            //获取单据编号
            //this.getDocuments(); 
          }
          getData.bind(this)()
        }
      }).catch((res) => {
        this.listsLoading = false;
      });
    },


    totalRule() {
      var _this = this;
      var num = 0;
      var total = 0;
      this.lists.forEach(function (e, index) {
        num += parseInt(e.num);
        total += parseFloat(e.total);
      });

      total = total.toFixed(2);
      if (this.goodsLocationStatus) {
        return ['合计', '', '', '', '', '', num, total, '', '', ''];
      } else {
        return ['合计', '', '', '', '', num, total, '', '', ''];
      }
    },
    showSelectLocation(index, row) {
      this.editListIndex = index
      this.editRow = row
      this.locationDropdownList()
    },
    locationDropdownList() {
      if (!this.editRow.warehouse) {
        this.$message.error('请先选择收货仓库')
        return
      }
      this.locationDialog = true
      const address_url = this.GLOBAL.domain + "StorageLocation/select_list"
      const send_data = {
        warehouse_id: this.editRow.warehouse,
        token: this.$cookies.get('token'),
        ...this.locationParams
      }
      var resource = this.$resource(address_url);
      this.locationDialogLoading = true
      resource.save(send_data).then((res) => {
        if (res.data.Result > 0) {
          this.locationList = []
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          if (Array.isArray(result.data) && result.data.length > 0) {
            for (const i of result.data) {
              i["id"] = i["id"].toString()
            }
          }
          this.locationList = result.data
          this.locationParams.total = result.total
        }
      }).catch((res) => {
        this.locationList = []
        this.$message.error(this.GLOBAL.errortext);
      }).finally(() => {
        this.locationDialogLoading = false
      })
    },
    locationPageSizeChange(val) {
      this.locationParams.rollpage = val;
      this.locationDropdownList();
    },
    locationPageCurrentChange(val) {
      this.locationParams.p = val;
      this.locationDropdownList();
    },
    selectLocation(row) {
      const list = JSON.parse(JSON.stringify(this.lists))
      list[this.editListIndex] = {
        ...list[this.editListIndex],
        storage_location_id: row.id,
        full_code: row.full_code,
      }
      this.lists = list

      this.locationDialog = false

      this.locationParams.p = 1
      this.locationList = []
      this.changeStorageLocation(this.lists[this.editListIndex])

    },



    /** 重置退货单数据 **/
    resetcreate() {
      const _this = this;
      //this.create.note='';
      //this.create.account='';
      //this.create.nums=this.nums;
      //this.create.totals='';
      //this.create.warehouses='';
      if (this.lists.length > 0) {
        this.lists.forEach(function (e, index) {
          _this.buys.splice(index, 1, e.buy);
          _this.nums.splice(index, 1, e.num);
          _this.totals.splice(index, 1, e.total);
          _this.validitys.splice(index, 1, e.validity);
          _this.warehouses.splice(index, 1, e.warehousename);
        });
      }
    },

    /** 出库单号 **/
    getDocuments() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getxsdocuments', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.create.documents = result;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取客户 **/
    getCustomer(query) {
      if (query !== '') {
        this.customerLoading = true;
        var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
        resource.query({ act: 'lists', key: query, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.customerLoading = false;
          } else {
            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
            this.customerLoading = false;
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
          this.customerLoading = false;
        });
      }
    },

    //切换客户名称
    changecustomer() {
      this.create.customer = this.customer;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changecustomer', token: this.$cookies.get('token'), customerid: this.create.customer, id: this.create.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.customer = '';
          this.create.customer = '';
          this.productquery.customerid = '';
        } else {
          this.productquery.customerid = this.create.customer;
        }
      }).catch((res) => {

      });
    },

    /** 添加退货商品 **/
    addDialogShow() {
      this.addDialog = true;
      this.multipleSelection = []; //清空已选中的商品
      this.productquery.customerid = '';
      this.productquery.id = this.create.id;
      this.getProductList();
    },

    /** 产品信息列表 **/
    getProductList() {
      if (this.isnewselect == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      this.addListLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows = parseInt(res.data.count);
          this.addListLoading = false;
          this.resetgoods();
        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },
    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList();
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList();
    },


    ////////////////////////////////////////////////////////////////////////////////////////////////

    /** 勾选/取消单个产品 **/
    handleselect(event, row) {
      this.handleSelectRow(row, event, false);
    },

    /** 点击单行选择产品 **/
    handleSelectRow(row, event, showlabel = true) {
      if (this.isselectpaynums) return false;

      var _this = this;
      var id = row.id;
      var isselect = 0;
      var number = 0;
      this.isselectall = false; //关闭点击单个勾选触发

      //勾选/取消勾选商品
      if (showlabel) {
        this.productlists.forEach(function (e, index) {
          if (e.id == id) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index])
        });
      }

      //添加、移除勾选的商品
      this.multipleSelection.forEach(function (e, index) { if (id == e.id) { isselect = 1; number = index; } });
      isselect == 1 ? this.multipleSelection.splice(number, 1) : this.multipleSelection.push(row);
      this.isselectall = true; //开启点击单个勾选触发
    },


    /** 选择商品信息  **/
    addmultipleTable(val) {
      if (this.isselectpaynums) return false;

      var _this = this;
      var number = -1;
      var data = [];
      var type = 1;   // 1、检测，需要新增 2、检测需要移除
      val.length > 0 ? type = 1 : type = 2;
      val.length > 0 ? data = val : data = this.productlists;

      if (type == 1) { //检测新增
        data.forEach(function (t, i) {
          number = -1;
          _this.multipleSelection.forEach(function (tt, ii) {
            if (t.id == tt.id) number = ii;
          });
          if (number == -1) _this.multipleSelection.push(t);
        });

      } else { //检测移除
        data.forEach(function (t, i) {
          number = -1;
          _this.multipleSelection.forEach(function (tt, ii) {
            if (t.id == tt.id) number = ii;
          });
          if (number >= 0) _this.$delete(_this.multipleSelection, number);
        });
      }

    },


    /** 匹配勾选的商品信息 **/
    resetgoods() {
      var _this = this;
      var ids = [];
      var number = -1;

      this.multipleSelection.forEach(function (e, index) { ids.push(e.id) });
      setTimeout(function () {
        number = -1;

        //已添加的商品默认勾选
        _this.productlists.forEach(function (e, index) {
          number = ids.indexOf(e.id);

          if (number >= 0) {
            _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
            e.paynums = _this.multipleSelection[number].paynums;
          }
        });
      }, 100);
    },

    /** 清空已选中的商品信息 **/
    cleargoods() {
      this.multipleSelection = [];
      //清除勾选的商品信息
      this.$refs.multipleTable.clearSelection();
    },

    /** 聚焦 **/
    paynumfocus() {
      this.isselectpaynums = true;
    },

    /** 失焦 **/
    paynumblur(item) {
      if (Number(item.paynums) > Number(item.refundnum)) {
        this.$message.error('退货数量不能大于可退数量');
        item.paynums = 1;

        var _this = this;
        this.multipleSelection.forEach(function (tt, ii) {
          if (item.id == tt.id) tt.paynums = item.paynums;
        });
        this.isselectpaynums = false;
        return false;

      } else {
        var _this = this;
        this.multipleSelection.forEach(function (tt, ii) {
          if (item.id == tt.id) tt.paynums = item.paynums;
        });
        this.isselectpaynums = false;
      }
    },
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    /** 清空购物车里的商品 **/
    delcart() {
      this.$confirm('您确定要清空购物车里的商品，继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delAll', token: this.$cookies.get('token'), id: this.create.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('清空购物车商品信息成功!');
            this.getLists();
            //this.getTotal();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        //this.$message.info('已取消操作!');
      });
    },


    /** 修改单位名称 **/
    changeUnit(item) {
      this.unitDialog = true;
      this.unitListLoading = true;
      this.changeunitid = item.id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getunit', productid: item.productid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
    },


    /** 确认修改单位 **/
    changeUnitSave(item) {
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeunit', id: item.id, customer: this.productquery.customerid, tempid: this.changeunitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitListLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
      this.unitDialog = false;
    },


    /** 修改数量 **/
    changeNum(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changenum_news', id: item.id, num: item.num, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        } else {
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },

    /** 修改退货价 **/
    changebuys(item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changebuys_news', id: item.id, buy: item.buy, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getLists();
        } else {
          this.listLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 修改小计 **/
    changeTotal(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetotal', id: item.id, total: this.totals[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.getLists();
          //this.getTotal();
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 修改仓库信息 **/
    changeWarehouse(index, item) {
      this.tempid = item.id;
      this.wareDialog = true;
    },

    /** 修改生产日期 **/
    changeValidity(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changecreatedate', id: item.id, validity: item.validity, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        this.listLoading = false;
      });
    },

    /** 保存修改的仓库信息 **/
    changeWareSave(item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeware', id: this.tempid, warehouse: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.wareDialog = false;
        } else {
          this.listLoading = false;
          this.getLists();
          this.wareDialog = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
        this.wareDialog = false;
      });
    },

    /** 获取总价 **/
    getTotal() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'gettotal', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.totalPrice = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
      this.isnewselect = true;
      this.getProductList();
    },

    /** 获取产品分类 **/
    getCategoryList() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 确认添加商品进入购物车 **/
    addSave() {
      //获取仓库信息列表里的第一条仓库信息（入库缓存里不可以没有仓库信息）
      this.addProductLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addproduct_news', data: JSON.stringify(this.multipleSelection), token: this.$cookies.get('token'), id: this.create.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addProductLoading = false;
        } else {
          this.$message.success("保存退货商品信息成功");
          this.addDialog = false;
          this.addProductLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addDialog = false;
        this.addProductLoading = false;
      });
    },

    /** 获取仓库列表 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取银行帐户 **/
    getAccount() {
      var resource = this.$resource(this.GLOBAL.domain + "Account/index");
      resource.query({ act: 'lists', isdeposit: 1, isnopay: 1, token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取销售员 **/
    getSeller() {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 修改每页条数 **/
    changepagevlaue() {
      this.changepage();
    },

    /** 设置分页设置 **/
    changepage() {
      this.printLoading = true;
      var number = this.rollpage; //系统设置的每页条数
      this.prtotal = this.printorderdetail.goods.length; //总条数
      this.prpage = [];
      this.prollpage = [];

      if (number >= this.prtotal) {
        this.prpage.push({ id: 1 });
        this.prollpage.push({ startpage: 0, endpage: number });
        this.allprintpage = 1;
      } else {
        var tnumber = parseInt(this.prtotal / number);
        var lnumber = this.prtotal % number;
        var index;
        var start;
        var end;
        lnumber > 0 ? tnumber++ : '';
        this.allprintpage = tnumber;

        for (var i = 0; i < tnumber; i++) {
          index = i + 1;
          this.prpage.push({ id: index });
          start = i * number;
          end = index * number - 1;
          this.prollpage.push({ startpage: start, endpage: end });
        }
      }
      this.printLoading = false;
    },

    /** 订单信息打印 **/
    createnoSave() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'updateprintnumber', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.printlocalpage(); //打印 
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      //设置打印完成后回调页面
      this.$cookies.set('returnurlids', '1,99');
      //设置打印信息
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;
      location.reload();
      this.$emit('closechild', 'Refundedit'); //关闭窗口
    },

    /** 保存修改的仓库信息 **/
    changeWareSave(item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeware', id: this.tempid, warehouse: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.wareDialog = false;
        } else {
          this.listLoading = false;
          this.getLists();
          this.wareDialog = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
        this.wareDialog = false;
      });
    },

    /** 获取客户信息 **/
    getcustomerinfo(id) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'getcustomerinfo', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.contactname = result.name;
          this.contactphone = result.phone;
          this.contactaddress = result.address;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 删除 **/
    deltempCurrent(item) {
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getLists();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

    /** 确认退货 **/
    createPrint() {
      this.saveorderLoading = true;
      var resource = this.$resource(this.url);
      this.create.act = 'addrefund_news';
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveorderLoading = false;
        } else {
          this.$message.success('退货入库成功！');
          this.saveorderLoading = false;
          this.$emit('closechild', 'Refundadd'); //关闭窗口
          //this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.saveorderLoading = false;
      });
    },


    /** 审核订单信息 **/
    verifysave() {
      this.verifyLoading = true;
      var resource = this.$resource(this.url);
      this.create.act = 'verifysave_news';
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.verifyLoading = false;
        } else {
          this.$message.success('退货入库成功！');
          this.verifyLoading = false;
          this.$emit('closechild', 'Refundadd'); //关闭窗口
          //this.getLists();
        }
      }).catch((res) => {
        this.verifyLoading = false;
      });
    },


    /** 确认退货并打印 **/
    createandPrint() {
      this.saveandprintLoading = true;
      var resource = this.$resource(this.url);
      this.create.act = 'verifysave_news';
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveandprintLoading = false;
        } else {
          this.$message.success('退货入库成功！');
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.saveandprintLoading = false;
          this.getprintdetail(result.id);
          //this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.saveandprintLoading = false;
      });
    },

    //获取订单打印信息
    getprintdetail(id) {
      this.printerDialog = true;
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printorderdetail = JSON.parse(Base64.decode(res.data.Data));
          //对商品进行分页设置
          var number = this.rollpage; //系统设置的每页条数
          this.prtotal = this.printorderdetail.goods.length; //总条数
          this.prpage = [];
          this.prollpage = [];

          if (number >= this.prtotal) {
            this.prpage.push({ id: 1 });
            this.prollpage.push({ startpage: 0, endpage: number });
            this.allprintpage = 1;
          } else {
            var tnumber = parseInt(this.prtotal / number);
            var lnumber = this.prtotal % number;
            var index;
            var start;
            var end;
            lnumber > 0 ? tnumber++ : '';
            this.allprintpage = tnumber;
            for (var i = 0; i < tnumber; i++) {
              index = i + 1;
              this.prpage.push({ id: index });
              start = i * number;
              end = index * number - 1;
              this.prollpage.push({ startpage: start, endpage: end });
            }
          }
          this.printLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
    },

    //关闭打印窗口
    closeprint() {
      this.printerDialog = false;
      this.$emit('closechild', 'Refundedit'); //关闭窗口
    },
    warehouseChange(item) {
      if (Array.isArray(this.warehouseNew) && this.warehouseNew.length > 0) {
        for (const element of this.warehouseNew) {
          if (item.warehouse == element.id) {
            const tempLists = this.lists
            for (const element_ of tempLists) {
              element_.location_children = element.children
              element_.storage_location_id = ""
              element_.warehouse = item.warehouse
              this.changeWarehouseLocation(element_)
              this.changeStorageLocation(element_)
            }
            this.lists = tempLists
          }
        }
      }
    },
    locationSearch() {
      this.locationParams.p = 1
      this.locationDropdownList()
    },
    changeWarehouseLocation(e) {
      const address_url = this.GLOBAL.domain + "Refund/index"
      const send_data = { act: "changeWarehouse", id: e.id, warehouse_id: e.warehouse, token: this.$cookies.get('token') }
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if (res.data.Result > 0) {
          this.$message.error(res.data.Message);
        } else {
          // var result = JSON.parse(Base64.decode(res.data.Data));
          // console.log(result)
          this.getLists()
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },
    changeStorageLocation(e) {
      const address_url = this.GLOBAL.domain + "/Refund/index"
      const send_data = { act: "changeStorageLocation", id: e.id, storage_location_id: e.storage_location_id, token: this.$cookies.get('token') }
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if (res.data.Result > 0) {
          this.$message.error(res.data.Message);
        } else {
          // var result = JSON.parse(Base64.decode(res.data.Data));
          // console.log(result)
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },
    getLatestWarehouse() {
      return new Promise(resolve => {
        const address_url = this.GLOBAL.domain + "/StorageLocation/warehouse_storage_location_cascade"
        const send_data = { token: this.$cookies.get('token') }
        var resource = this.$resource(address_url);
        resource.save(send_data).then((res) => {
          if (res.data.Result > 0) {
            resolve([])
            this.$message.error(res.data.Message);
          } else {
            var result = JSON.parse(Base64.decode(res.data.Data));
            if (Array.isArray(result) && result.length > 0) {
              for (const i of result) {
                i["id"] = i["id"].toString()
                if (Array.isArray(i["children"]) && i["children"].length > 0) {
                  for (const j of i["children"]) {
                    j["id"] = j["id"].toString()
                  }
                }
              }
            }
            resolve(result)
            // console.log(result)
          }
        }).catch((res) => {
          resolve([])
          this.$message.error(this.GLOBAL.errortext);
        });
      })
    },
    checkLocationStatus() {
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus") || ''
      if (goodsLocationStatus == "true") {
        this.goodsLocationStatus = true
      } else {
        this.goodsLocationStatus = false
      }
    },
  }
}
</script>
<style type="text/css">
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

#showselectgoods {
  display: none;
  position: fixed;
  width: 2%;
  height: 100%;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 10000;
}

#showselectgoods #selecttitle {
  width: 100%;
  float: left;
  color: #fff;
  text-align: center;
  font-size: 15px;
  padding: 20px 0 20px 0;
  font-size: 15px
}

#showselectgoods #selectdata {
  display: none
}

#showselectgoods:hover {
  width: 30%;
  background-color: #FFF;
  box-shadow: #000 10px 10px 35px;
  transition: width 0.5s;
}

#showselectgoods:hover #selecttitle {
  color: #606266;
  font-size: 13px
}

#showselectgoods:hover #selectdata {
  display: block;
  width: 90%;
  margin-top: 20px;
  margin-left: 5%;
  height: 85%;
  overflow: auto
}

.cz-sell-base-lists-infos-out {
  display: inline-block;
  width: 100%;
}

.cz-sell-base-lists-infos {
  float: left;
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 0;
  width: 25%;
  height: 50px;
  overflow: hidden;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {
  float: left;
  text-align: right;
  font-size: 13px;
  line-height: 23px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {
  float: left;
  margin-left: 10px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {
  text-align: left;
  width: 220px;
  border-bottom: 1px solid #dcdfe6;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {
  box-shadow: none;
  border-bottom: 1px solid #dcdfe6;
}

.cz-sell-base-lists-infos .el-input.is-active .el-input__inner,
.cz-sell-base-lists-infos .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {
  margin-top: 7px
}

.cz-sell-base-lists-infos-goods {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}

.cz-sell-base-lists-infos-goods .el-table {
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  background: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table td,
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,
.cz-sell-base-lists-infos-goods .el-table .hover-row>td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {
  background: #E4E7ED;
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border-bottom: none;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-input__inner:hover {
  box-shadow: none;
  border: none;
}

.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td,
.cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #E4E7ED;
}

.cz-table-refund-num-style1 .el-input__inner {
  border: 1px solid #dcdfe6;
  border-radius: 15px 0 0 15px;
}
</style>
<style scoped>
.link-style {
  cursor: pointer;
}

.link-style:hover {
  text-decoration: underline;
  color: #1488f5;
}
.click-ware-lists:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Refundadd.vue